import cs from "classnames";
import React from "react";
import { MdOutlineSearch } from "react-icons/md";
import { useIntl } from "react-intl";

import { genericMessages } from "src/messages/generic";

import "./Search.css";

interface SearchProps {
	query: string;
	onChangeQuery(query: string): unknown;
}

export const Search: React.FunctionComponent<SearchProps> = ({
	query,
	onChangeQuery
}) => {
	const { formatMessage } = useIntl();

	const [isFocused, setFocused] = React.useState(false);

	const onFocus = React.useCallback(() => {
		setFocused(true);
	}, []);

	const onBlur = React.useCallback(() => {
		setFocused(false);
	}, []);

	const onChange = React.useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			onChangeQuery(event.target.value);
		},
		[onChangeQuery]
	);

	return (
		<div
			className={cs("dashboard-search", {
				"dashboard-search--focused": isFocused
			})}
		>
			<MdOutlineSearch />
			<input
				type="text"
				placeholder={formatMessage(genericMessages.searchOnPage)}
				value={query}
				onFocus={onFocus}
				onBlur={onBlur}
				onChange={onChange}
			/>
		</div>
	);
};
